<div [class.readonly]="readonly" >
    <ng-content></ng-content>
</div>